import { Link, useLocation } from 'react-router-dom';
import './NotFound.css';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="not-found-page">
      <div className="not-found-card">
        <p className="not-found-code">404</p>
        <h1 className="not-found-title">We couldn't find that page</h1>
        <p className="not-found-text">
          Nothing lives at <span className="not-found-path">{location.pathname}</span>. It may
          have moved, or the link that brought you here may be out of date.
        </p>
        <div className="not-found-actions">
          <Link to="/" className="not-found-btn not-found-btn-primary">
            Back to Home
          </Link>
          <Link to="/products" className="not-found-btn not-found-btn-secondary">
            Browse Products
          </Link>
        </div>
      </div>
    </div>
  );
}
